const PLACEHOLDER_PATTERN = /\$\$|\$([^$]+)\$/g;

export const getTemplatePlaceholders = (template) => {
  if (!template) return [];

  const templateString = typeof template === "string" ? template : JSON.stringify(template);
  const matches = [...templateString.matchAll(PLACEHOLDER_PATTERN)].filter((match) => match[1] !== undefined);

  return [...new Set(matches.map((match) => match[0]))];
};

export const parseTemplateBody = (template) => {
  if (!template) return {};
  if (typeof template !== "string") return template;

  try {
    return JSON.parse(template);
  } catch {
    return {};
  }
};
